export enum WriteOffStatus {
    CREATED = 'CREATED',
    APPROVED = 'APPROVED',
    APPLIED = 'APPLIED',
    DENIED = 'DENIED',
    ERROR = 'ERROR'
  }